module.exports = __webpack_public_path__ + "img/2.d35cce5c.png";